<template>
  <div>
    <tabs
      v-if="isSearch"
      :delUrl="delUrl"
      @searchData="searchData"
      @resetData="searchData"
    ></tabs>
    <refreshbtn @refesh="refesh" :isBetWeen="true">
      <template slot="left_btn">
        <template  v-if="!userInfo.is_outer">
          <el-button size="small" type="success" @click="batchlaunch"
            >批量上线</el-button
          >
          <el-button size="small" type="danger" @click="openSetTags"
            >批量设置标签</el-button
          >
          <el-button size="small" type="success" @click="batchlaunchoff"
            >批量弃用</el-button
          >
          <el-button size="small" type="success" @click="deleteData"
            >一键删除</el-button
          >
        </template>
        <el-button size="small" type="success" v-has="editMediaUrl" @click="remoteVisual"
          >远程视觉</el-button
        >
        <el-button size="small" type="success" v-has="editFillingUrl" @click="remoteOperation"
          >远程运营</el-button
        >
      </template>
      <template slot="search-btns">
        <el-button
          title="普通搜索"
          size="small"
          icon="el-icon-search"
          @click="isSearch = !isSearch"
        ></el-button>
      </template>
    </refreshbtn>
    <videoTable
      ref="table"
      :isSelect="true"
      :axiosTile="axiosTile"
      @lookVideo="lookVideo"
      :headerList="headerList"
      :isLook="true"
      :editUrl="'/api/video/short/update'"
      :checkUrl="'/api/video/short/checkRS'"
      :deleteUrl="'/api/video/short/destroy'"
      :editTimestampUrl="'/api/video/short/update'"
      :tableData="tableData"
      @editData="editData"
      :total="total"
      :pages="search.page"
      :delFIle="delUrl"
      @editTimestamp="editTimestamp"
      @editRichText="editRichText"
      :isHideEditRichText="true"
    />
    <videoDialog
      :data="editOpen"
      :isLook="true"
      @clearData="clearData"
      @pushData="updateData"
      ref="dialog"
    ></videoDialog>
    <lookVideoDialog ref="lookDialog" :isLook="isLook" :isVideo="true" @handlerSave="refesh"></lookVideoDialog>
    <!--批量标签话题编辑弹窗-->
    <batch-tags-popup
      ref="batchTagsPopup"
      @handlerClose="handlerClose"
    ></batch-tags-popup>
    <add-remote-dialog ref="addRemoteDialog" :media_type="1"></add-remote-dialog>
    <RichEditor ref="richText" @handlerLoadList="handlerClose" :isDataFill="false"></RichEditor>
  </div>
</template>

<script>
import videoTable from "./components/videoTable";
import tabs from "./components/tabs";
import videoDialog from "./components/videoDialog";
import lookVideoDialog from "./components/lookVideoDialog";
import API from "@/api";
import local from "@/utils/localStroage.js";
import BatchTagsPopup from "./components/batchTagsPopup";
import AddRemoteDialog from "./components/addRemoteDialog";
import RichEditor from "@/components/rich-editor";

export default {
  name: "shortVideo",
  components: {
    videoTable,
    tabs,
    videoDialog,
    lookVideoDialog,
    BatchTagsPopup,
    AddRemoteDialog,
    RichEditor,
  },
  data() {
    return {
      search: {
        page: 1,
        size: 10,
      },
      total: 0,
      axiosTile: "/short",
      delUrl: "/api/video/short/destroy",
      editOpen: {},
      headerList: [
        {
          key: "短视频ID",
          value: "id",
          align: "center",
        },
        {
          key: "UP主",
          value: "vlogger",
          align: "center",
          type: "obj",
          objValue: "account",
        },
        {
          key: "唯一标识",
          value: "hash_id",
          align: "center",
          minWidth: "350",
        },
        {
          key: "文件资源id",
          value: "fs_resource_id",
          align: "center",
          minWidth: "100",
        },
        {
          key: "文件状态",
          value: "fs_resource_status",
          align: "center",
          width: "100",
          dictionary: [
            { key: "Waiting", value: "待检查" },
            { key: "Uploading", value: "文件上传中" },
            { key: "UploadError", value: "文件上传失败" },
            { key: "UploadCompleted", value: "文件上传完成" },
            { key: "FileMerging", value: "文件合并中" },
            { key: "FileConverting", value: "文件转换中" },
            { key: "FileMergeError", value: "文件合并失败" },
            { key: "FileConvertError", value: "文件转换失败" },
            { key: "CompletedFail", value: "处理失败" },
            { key: "CompressCompleted", value: "压缩完成" },
            { key: "Completed", value: "处理完成" },
          ],
          type: "dictionary",
        },
        {
          key: "主视频",
          value: "video_id",
          minWidth: "100",
        },
        {
          key: "短视频标题",
          value: "title",
          minWidth: "350",
        },
        {
          key: "视频封面",
          value: "cover_image",
          type: "image",
          align: "center",
        },
        {
          key: "视频宽度px",
          value: "width",
          type: "unit",
          unit: "px",
          align: "center",
          minWidth: "100",
        },
        {
          key: "视频高度px",
          value: "height",
          type: "unit",
          unit: "px",
          align: "center",
          minWidth: "100",
        },
        {
          key: "是否竖版视频",
          value: "is_vertical",
          type: "Boolean",
          align: "center",
          minWidth: "120",
        },
        {
          key: "视频长度",
          value: "length",
          type: "sfmTime",
          align: "center",
        },
        {
          key: "480p地址",
          value: "src_480",
          align: "center",
          minWidth: "250",
          type: "src",
        },
        {
          key: "480P文件大小",
          value: "file_size_480",
          type: "size",
          align: "center",
          width: "120",
        },
        {
          key: "标签",
          value: "tags_text",
          minWidth: "160",
          align: "center",
        },
        // {
        //   key: "入库时间",
        //   value: "create_time",
        //   type: "time",
        //   align: "center",
        //   width: "160",
        // },
        // {
        //   key: "更新时间",
        //   value: "update_time",
        //   type: "time",
        //   align: "center",
        //   width: "160",
        // },
        {
          key: "来源产品",
          value: "from_pro_id",
          align: "center",
        },
        {
          key: "数据版本",
          value: "data_version",
          align: "center",
        },
        {
          key: "编辑者",
          value: "edit_by",
          minWidth: "100",
          align: "center",
        },
        // {
        //   key: "上传者",
        //   value: "terminal_cdo",
        //   fixed: true,
        //   minWidth: "100",
        //   align: "center",
        // },
        {
          key: "弃用理由",
          value: "refuse_reason",
          align: "center",
          width: "100",
        },
        {
          key: "状态",
          value: "status",
          width: "100",
          type: "dictionary",
          align: "center",
          fixed: true,
          dictionary: [
            {
              key: 0,
              value: "准备中",
            },
            {
              key: 7,
              value: "弃用",
            },
            {
              key: 10,
              value: "完成&可使用",
            },
          ],
        },
      ],
      tableData: [],
      isSearch: false,
      isRefesh: true,
      userInfo: undefined,
      editMediaUrl: "/api/task/filling/create",
      editFillingUrl: "/api/task/point/batch/create",
      isLook: false,
    };
  },
  created() {
    this.userInfo = local.get("userInfo");
    if (!this.userInfo.is_outer) {
      this.headerList.splice(15, 0, {
        key: "入库时间",
        value: "create_time",
        type: "time",
        align: "center",
        width: "160",
      });
      this.headerList.splice(16, 0, {
        key: "更新时间",
        value: "update_time",
        type: "time",
        align: "center",
        width: "160",
      });
      this.headerList.splice(20, 0, {
        key: "上传者",
        value: "terminal_cdo",
        fixed: true,
        minWidth: "100",
        align: "center",
      });
    }
    // let listRule = "/api/video/short/list";
    // let obj = JSON.parse(
    //   JSON.parse(JSON.stringify(localStorage.getItem("btnPower")))
    // );
    // if (obj[listRule]) {
    //   this.isRefesh = true;
    //   this.getVideoList();
    // } else {
    //   this.isRefesh = false;
    // }
    this.getVideoList();
  },
  methods: {
    editRichText(data) {
      this.$refs.richText.open(data);
    },
    // 批量上线
    async batchlaunch() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({ type: "warning", message: "请选择要上线的数据" });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      const { msg, code, data } = await API.onlineVideoshort({ ids: ids });
      if (!code) {
        this.$message.success(
          "成功上线" + data.success + "条数据，失败" + data.failure + "条"
        );
        this.getVideoList(this.search.page);
      } else {
        this.$message.error(msg);
      }
    },
    // 批量设置标签
    async openSetTags() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量设置标签的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.batchTagsPopup.open(ids);
    },
    // 批量下线
    async batchlaunchoff() {
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({ type: "warning", message: "请选择要弃用的数据" });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$prompt("请输入弃用理由", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          this.handlebatchlaunchoff(ids, value);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    // 批量下线
    async handlebatchlaunchoff(ids, refuse_reason) {
      const { msg, code, data } = await API.offlineVideoshort({
        ids: ids,
        refuse_reason: refuse_reason,
      });
      if (!code) {
        this.$message.success(
          "成功弃用" + data.success + "条数据，失败" + data.failure + "条"
        );
        this.getVideoList(this.search.page);
      } else {
        this.$message.error(msg);
      }
    },
    refesh() {
      this.isRefesh ? this.getVideoList() : "";
    },
    async getVideoList(page) {
      this.$nextTick(() => {
        this.$refs.table.loading = true;
      });
      // 获取视频列表
      this.search.page = page || 1;
      const { data, code } = await API.getVideoList(
        this.search,
        this.axiosTile
      );
      if (!code) {
        this.tableData = data.data;
        this.total = data.pagination.count;
        this.$refs.table.loading = false;
      } else {
        this.tableData = [];
        this.total = 0;
        this.$refs.table.loading = false;
      }
    },
    clearData() {
      this.$refs.dialog.openDialog = false;
      this.editOpen = {};
    },
    async updateData(data) {
      const { code, msg } = await API.updateVideoData(data);
      if (!code) {
        this.$message.success("编辑短视频成功");
        this.getVideoList(this.search.page);
        this.$refs.dialog.loading = false;
        this.$refs.dialog.openDialog = false;
        this.editOpen = {};
      } else {
        this.$message.error(msg);
        this.$refs.dialog.loading = false;
        this.$refs.dialog.openDialog = false;
        this.editOpen = {};
      }
    },
    editData(data) {
      this.editOpen = JSON.parse(JSON.stringify(data));
      this.$refs.dialog.openDialog = true;
      this.$refs.dialog.loadVideo(data.src_480);
      this.$refs.dialog.delUrl = this.delUrl;
      this.$refs.dialog.getTargetTree();
    },
    async deleteData() {
      const { code, msg } = await API.destoryAllShortVideo({ id: "" });
      if (!code) {
        this.$message.success("一键删除成功");
        this.getVideoList(this.search.page);
        this.$refs.dialog.loading = false;
      } else {
        this.$message.error(msg);
        this.$refs.dialog.loading = false;
      }
    },
    searchData(data) {
      this.search = { page: 1, size: 10 };
      if (this.isRefesh) {
        data
          ? (this.search = Object.assign(this.search, data))
          : (this.search = { page: 1, size: 10 });
        this.getVideoList();
      }
    },
    lookVideo(data) {
      this.isLook = true;
      this.$refs.lookDialog.openlookDialog = true;
      this.$refs.lookDialog.loadVideo(data.src_480);
    },
    editTimestamp(data) {
      this.isLook = false;
      this.$refs.lookDialog.openlookDialog = true;
      this.$refs.lookDialog.loadVideo(data.src_480, data);
    },
    async changeSize(pageSize) {
      this.search.page = 1;
      this.search.size = pageSize;
      this.getVideoList();
    },
    handlerClose() {
      this.getVideoList();
    },
    remoteVisual() {
      console.log("远程视觉");
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量添加远程视觉的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.addRemoteDialog.open(ids, 'add', 'remote_visual');
    },
    remoteOperation() {
      console.log("远程运营");
      if (!this.$refs.table.multipleSelection.length) {
        this.$message({
          type: "warning",
          message: "请选择要批量添加远程运营的数据",
        });
        return false;
      }
      let ids = [];
      this.$refs.table.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      this.$refs.addRemoteDialog.open(ids, 'add', 'remote_operation');
    },
  },
};
</script>

<style scoped></style>
